<div class="drawer-overlay" (click)="onCancel()">
  <div class="drawer" (click)="onWindowClick($event)">
    <div class="drawer-header">
      <h3>{{ 'COMMON.ADD_FILTER.PLURAL' | translate }}</h3>
    </div>

    <div class="drawer-body">
      <ul>
        <ng-container *ngFor="let option of dynamicFilterOptions">
          <li class="filter-item" *ngIf="option.staticPropertyName === 'Date'">
            <ng-container [ngTemplateOutlet]="dateFilter"></ng-container>
          </li>
          <li class="filter-item" *ngIf="option.staticPropertyName === 'RegionDistrict'">
            <ng-container [ngTemplateOutlet]="regionFilter"></ng-container>
          </li>
          <li class="filter-item" *ngIf="option.staticPropertyName === 'GeoSubGeoRegion'">
            <ng-container [ngTemplateOutlet]="geoRegionFilter"></ng-container>
          </li>
          <li class="filter-item" *ngIf="option.staticPropertyName === 'ValidationStatus'">
            <ng-container [ngTemplateOutlet]="validationStatusFilter"></ng-container>
          </li>
          <li class="filter-item" *ngIf="option.staticPropertyName === 'ReviewStatus'">
            <ng-container [ngTemplateOutlet]="reviewStatusFilter"></ng-container>
          </li>
          <li class="filter-item" *ngIf="option.staticPropertyName === 'Tag'">
            <ng-container [ngTemplateOutlet]="tagFilter"></ng-container>
          </li>

          <li class="filter-item" *ngIf="!option.attributeDefinitionId && option.staticPropertyName === 'Users'">
            <ng-container [ngTemplateOutlet]="userTypeFilter"></ng-container>
          </li>
          <li class="filter-item" *ngIf="!option.attributeDefinitionId && option.staticPropertyName === 'Users'">
            <ng-container [ngTemplateOutlet]="usersFilter"></ng-container>
          </li>
        </ng-container>
      </ul>
    </div>

    <div class="drawer-footer">
      <button class="cancel-btn" (click)="onCancel()">{{ 'COMMON.CANCEL' | translate }}</button>
      <button class="add-filter-btn" (click)="onAddFilter()">{{ 'COMMON.ADD_FILTER.SINGLE' | translate }}</button>
    </div>
  </div>
</div>

<ng-template #dateFilter>
  <div class="filter-header" (click)="toggleFilter('date')">
    <div class="img-title-container">
      <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M3.125 8.12435H16.875M6.45833 3.95768V2.29102M13.5417 3.95768V2.29102M5.625 16.8744H14.375C15.7557 16.8744 16.875 15.7551 16.875 14.3744V6.45768C16.875 5.07697 15.7557 3.95768 14.375 3.95768H5.625C4.24429 3.95768 3.125 5.07697 3.125 6.45768V14.3744C3.125 15.7551 4.24429 16.8744 5.625 16.8744Z"
          [attr.stroke]="openedFilters.includes('date') ? 'var(--primary-color)' : '#17171A'" stroke-opacity="0.9" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
      </svg>
      <span class="filter-title" [class.date-open]="openedFilters.includes('date')">{{ 'COMMON.DATE' | translate }}</span>
    </div>
    <img src="../../../assets/icons/gray-arrow-down.svg" alt="Dropdown" [class.open]="openedFilters.includes('date')" />
  </div>
  <div *ngIf="openedFilters.includes('date')" class="date-filter-section">
    <div class="filter-row">
      <select [(ngModel)]="filter.filterParams.dateTypeString" class="full-width" (change)="onDateTypeChange()">
        <option *ngFor="let t of dateTypes" [value]="t">{{ t | translate }}</option>
      </select>
    </div>
    <div class="filter-row">
      <button class="full-width">
        <span>{{ 'COMMON.DATE_FROM' | translate }}: </span>
        <input type="date" [(ngModel)]="filter.filterParams.dateFrom" />
      </button>
      <button class="full-width">
        <span>{{ 'COMMON.DATE_TO' | translate }}: </span>
        <input type="date" [(ngModel)]="filter.filterParams.dateTo" />
      </button>
    </div>
  </div>
</ng-template>

<ng-template #regionFilter>
  <div class="filter-header" (click)="toggleFilter('region')">
    <div class="img-title-container">
      <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M10.0009 13.5417V16.875M10.0009 13.5417H5.03121C4.48967 13.5417 3.98189 13.2786 3.6696 12.8362L2.34607 10.9612C1.93933 10.3849 1.93933 9.61508 2.34607 9.03883L3.6696 7.16386C3.98189 6.72144 4.48967 6.45833 5.03121 6.45833H9.16758C9.62783 6.45833 10.0009 6.83143 10.0009 7.29167V13.5417ZM10.8342 3.125H14.9707C15.5122 3.125 16.02 3.38811 16.3323 3.83053L17.6558 5.70553C18.0626 6.28174 18.0626 7.05159 17.6558 7.62781L16.3323 9.50283C16.02 9.94525 15.5122 10.2083 14.9707 10.2083H10.8342C10.3741 10.2083 10.0009 9.83525 10.0009 9.375V3.95833C10.0009 3.4981 10.3741 3.125 10.8342 3.125Z"
          [attr.stroke]="openedFilters.includes('region') ? 'var(--primary-color)' : '#17171A'" stroke-opacity="0.9" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
      </svg>
      <span class="filter-title" [class.date-open]="openedFilters.includes('region')">
        {{ 'COMMON.BU.SINGLE' | translate }} & {{ 'COMMON.UT.SINGLE' | translate }}
      </span>
    </div>
    <img src="../../../assets/icons/gray-arrow-down.svg" alt="Dropdown" [class.open]="openedFilters.includes('region')" />
  </div>
  <div *ngIf="openedFilters.includes('region')" class="filter-section">
    <div class="region-area-container">
      <div class="region-column">
        <div class="search-row">
          <input type="text" placeholder="Search by region"
            [(ngModel)]="filter.filterParams.regionSearchText" />
        </div>
        <div class="region-list">
          <div *ngFor="let region of filteredRegions" class="region-item">
            <div class="region-header"
              [class.selected]="filter.filterParams.selectedRegionModel?.id === region.id"
              (click)="selectRegion(region)">
              <span>{{ region.name }}</span>
            </div>
          </div>
        </div>
      </div>
      <div *ngIf="filter.filterParams.selectedRegionModel" class="area-column">
        <div class="search-row">
          <input type="text" placeholder="Search by district"
            [(ngModel)]="filter.filterParams.areaSearchText" (ngModelChange)="updateAreas()" />
        </div>
        <div class="area-list">
          <div *ngFor="let area of areas" class="area-item">
            <input type="checkbox"
              [checked]="isAreaSelected({ id: area.id, name: area.name })"
              (change)="onAreaSelect({ id: area.id, name: area.name }, $event)" />
            <span>{{ area.name }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #geoRegionFilter>
  <div class="filter-header" (click)="toggleFilter('geo')">
    <div class="img-title-container">
      <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M10.0009 13.5417V16.875M10.0009 13.5417H5.03121C4.48967 13.5417 3.98189 13.2786 3.6696 12.8362L2.34607 10.9612C1.93933 10.3849 1.93933 9.61508 2.34607 9.03883L3.6696 7.16386C3.98189 6.72144 4.48967 6.45833 5.03121 6.45833H9.16758C9.62783 6.45833 10.0009 6.83143 10.0009 7.29167V13.5417ZM10.8342 3.125H14.9707C15.5122 3.125 16.02 3.38811 16.3323 3.83053L17.6558 5.70553C18.0626 6.28174 18.0626 7.05159 17.6558 7.62781L16.3323 9.50283C16.02 9.94525 15.5122 10.2083 14.9707 10.2083H10.8342C10.3741 10.2083 10.0009 9.83525 10.0009 9.375V3.95833C10.0009 3.4981 10.3741 3.125 10.8342 3.125Z"
          [attr.stroke]="openedFilters.includes('geo') ? 'var(--primary-color)' : '#17171A'" stroke-opacity="0.9" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
      </svg>
      <span class="filter-title" [class.date-open]="openedFilters.includes('geo')">
        Geographical & Sub-Geographical Region
      </span>
    </div>
    <img src="../../../assets/icons/gray-arrow-down.svg" alt="Dropdown" [class.open]="openedFilters.includes('geo')" />
  </div>
  <div *ngIf="openedFilters.includes('geo')" class="filter-section">
    <div class="region-area-container">
      <div class="region-column">
        <div class="search-row">
          <input type="text" placeholder="Search by region"
            [(ngModel)]="filter.filterParams.geoSearchText" />
        </div>
        <div class="region-list">
          <div *ngFor="let geo of filteredGeoRegions" class="region-item">
            <div class="region-header"
              [class.selected]="filter.filterParams.selectedGeoRegionModel?.id === geo.id"
              (click)="selectGeoRegion(geo)">
              <span>{{ geo.name }}</span>
            </div>
          </div>
        </div>
      </div>
      <div *ngIf="filter.filterParams.selectedGeoRegionModel" class="area-column">
        <div class="search-row">
          <input type="text" placeholder="Search by sub-region"
            [(ngModel)]="filter.filterParams.subGeoSearchText" (ngModelChange)="updateSubGeoRegions()" />
        </div>
        <div class="area-list">
          <div *ngFor="let sg of subGeoRegions" class="area-item">
            <input type="checkbox"
              [checked]="isSubGeoSelected({ id: sg.id, name: sg.name })"
              (change)="onSubGeoSelect({ id: sg.id, name: sg.name }, $event)" />
            <span>{{ sg.name }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #userTypeFilter>
  <div class="filter-header" (click)="toggleFilter('user-type')">
    <div class="img-title-container">
      <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M13.125 5.41602C13.125 7.14191 11.7259 8.54102 10 8.54102C8.27411 8.54102 6.875 7.14191 6.875 5.41602C6.875 3.69012 8.27411 2.29102 10 2.29102C11.7259 2.29102 13.125 3.69012 13.125 5.41602Z"
          [attr.stroke]="openedFilters.includes('user-type') ? 'var(--primary-color)' : '#17171A'" stroke-opacity="0.9" stroke-width="1.5" stroke-linejoin="round" />
        <path d="M9.9991 11.041C7.51704 11.041 5.56103 12.3359 4.52688 14.2594C3.82929 15.5569 5.02199 16.8743 6.49513 16.8743H13.503C14.9762 16.8743 16.1688 15.5569 15.4713 14.2594C14.4372 12.3359 12.4811 11.041 9.9991 11.041Z"
          [attr.stroke]="openedFilters.includes('user-type') ? 'var(--primary-color)' : '#17171A'" stroke-opacity="0.9" stroke-width="1.5" stroke-linejoin="round" />
      </svg>
      <span class="filter-title" [class.date-open]="openedFilters.includes('user-type')">{{ 'COMMON.USER.TYPE.TITLE' | translate }}</span>
    </div>
    <img src="../../../assets/icons/gray-arrow-down.svg" alt="Dropdown" [class.open]="openedFilters.includes('user-type')" />
  </div>
  <div *ngIf="openedFilters.includes('user-type')" class="user-type-filter-section">
    <label *ngFor="let option of userTypes">
      <input type="radio" name="userType" [value]="option.value"
        [(ngModel)]="filter.filterParams.selectedUserTypeString"
        (change)="onSelectUserType(option)" />
      <span class="option">{{ 'COMMON.USER.TYPE.' + option.label.toUpperCase() | translate }}</span>
    </label>
  </div>
</ng-template>

<ng-template #usersFilter>
  <div class="filter-header" (click)="toggleFilter('users')">
    <div class="img-title-container">
      <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M13.125 5.41602C13.125 7.14191 11.7259 8.54102 10 8.54102C8.27411 8.54102 6.875 7.14191 6.875 5.41602C6.875 3.69012 8.27411 2.29102 10 2.29102C11.7259 2.29102 13.125 3.69012 13.125 5.41602Z"
          [attr.stroke]="allUsers.length === 0 ? '#999' : openedFilters.includes('users') ? 'var(--primary-color)' : '#17171A'" stroke-opacity="0.9" stroke-width="1.5" stroke-linejoin="round" />
        <path d="M9.9991 11.041C7.51704 11.041 5.56103 12.3359 4.52688 14.2594C3.82929 15.5569 5.02199 16.8743 6.49513 16.8743H13.503C14.9762 16.8743 16.1688 15.5569 15.4713 14.2594C14.4372 12.3359 12.4811 11.041 9.9991 11.041Z"
          [attr.stroke]="allUsers.length === 0 ? '#999' : openedFilters.includes('users') ? 'var(--primary-color)' : '#17171A'" stroke-opacity="0.9" stroke-width="1.5" stroke-linejoin="round" />
      </svg>
      <span class="filter-title" [class.date-open]="openedFilters.includes('users')">{{ 'COMMON.USER.PLURAL' | translate }}</span>
    </div>
    <img src="../../../assets/icons/gray-arrow-down.svg" alt="Dropdown" [class.open]="openedFilters.includes('users')" />
  </div>
  <div *ngIf="allUsers.length > 0 && openedFilters.includes('users')" class="users-filter-section">
    <input type="text" class="user-search-input" placeholder="Search users..."
      [(ngModel)]="filter.filterParams.searchUsersText" />
    <label *ngFor="let user of filteredUsers">
      <input type="checkbox"
        [checked]="isUserSelected(user)"
        (change)="onSelectUser(user, $event)" />
      <span class="option">{{ user.name }}</span>
    </label>
  </div>
</ng-template>

<ng-template #validationStatusFilter>
  <div class="filter-header" (click)="toggleFilter('validation-status')">
    <div class="img-title-container">
      <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M7.29167 9.99917L9.09725 11.8742L12.7083 8.12417M3.125 10.8325V6.4459C3.125 5.4425 3.72492 4.53633 4.64863 4.14445L9.02367 2.28839C9.64767 2.02366 10.3523 2.02366 10.9763 2.28839L15.3513 4.14445C16.2751 4.53633 16.875 5.4425 16.875 6.4459V10.8325C16.875 14.6294 13.7969 17.7075 10 17.7075C6.20304 17.7075 3.125 14.6294 3.125 10.8325Z"
          [attr.stroke]="openedFilters.includes('validation-status') ? 'var(--primary-color)' : '#17171A'" stroke-opacity="0.9" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
      </svg>
      <span class="filter-title" [class.date-open]="openedFilters.includes('validation-status')">{{ 'COMMON.VALIDATION_STATUS' | translate }}</span>
    </div>
    <img src="../../../assets/icons/gray-arrow-down.svg" alt="Dropdown" [class.open]="openedFilters.includes('validation-status')" />
  </div>
  <div *ngIf="openedFilters.includes('validation-status')" class="validation-status-filter-section">
    <label *ngFor="let option of validationStatuses">
      <input type="checkbox" [value]="option.value"
        [checked]="isValidationStatusSelected(option.value)"
        (change)="onValidationStatusChange(option.value, $event)" />
      <span class="option">{{ 'COMMON.ASSET_STATUS.' + option.label.toUpperCase() | translate }}</span>
    </label>
  </div>
</ng-template>

<ng-template #reviewStatusFilter>
  <div class="filter-header" (click)="toggleFilter('review-status')">
    <div class="img-title-container">
      <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M7.29167 9.99917L9.09725 11.8742L12.7083 8.12417M3.125 10.8325V6.4459C3.125 5.4425 3.72492 4.53633 4.64863 4.14445L9.02367 2.28839C9.64767 2.02366 10.3523 2.02366 10.9763 2.28839L15.3513 4.14445C16.2751 4.53633 16.875 5.4425 16.875 6.4459V10.8325C16.875 14.6294 13.7969 17.7075 10 17.7075C6.20304 17.7075 3.125 14.6294 3.125 10.8325Z"
          [attr.stroke]="openedFilters.includes('review-status') ? 'var(--primary-color)' : '#17171A'" stroke-opacity="0.9" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
      </svg>
      <span class="filter-title" [class.date-open]="openedFilters.includes('review-status')">{{ 'COMMON.REVIEW_STATUS' | translate }}</span>
    </div>
    <img src="../../../assets/icons/gray-arrow-down.svg" alt="Dropdown" [class.open]="openedFilters.includes('review-status')" />
  </div>
  <div *ngIf="openedFilters.includes('review-status')" class="review-status-filter-section">
    <label *ngFor="let option of reviewStatuses">
      <input type="radio" name="reviewStatus" [value]="option.value" [(ngModel)]="filter.filterParams.reviewStatus" />
      <span class="option">{{ option.label }}</span>
    </label>
  </div>
</ng-template>

<ng-template #tagFilter>
  <div class="filter-header" (click)="toggleFilter('tag')">
    <div class="img-title-container">
      <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M7.29167 9.99917L9.09725 11.8742L12.7083 8.12417M3.125 10.8325V6.4459C3.125 5.4425 3.72492 4.53633 4.64863 4.14445L9.02367 2.28839C9.64767 2.02366 10.3523 2.02366 10.9763 2.28839L15.3513 4.14445C16.2751 4.53633 16.875 5.4425 16.875 6.4459V10.8325C16.875 14.6294 13.7969 17.7075 10 17.7075C6.20304 17.7075 3.125 14.6294 3.125 10.8325Z"
          [attr.stroke]="openedFilters.includes('tag') ? 'var(--primary-color)' : '#17171A'" stroke-opacity="0.9" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
      </svg>
      <span class="filter-title" [class.date-open]="openedFilters.includes('tag')">{{ 'COMMON.TAG.TITLE' | translate }}</span>
    </div>
    <img src="../../../assets/icons/gray-arrow-down.svg" alt="Dropdown" [class.open]="openedFilters.includes('tag')" />
  </div>
  <div *ngIf="openedFilters.includes('tag')" class="tag-filter-section">
    <label *ngFor="let option of tagOptions">
      <input type="radio" name="tag" [value]="option.value" [(ngModel)]="filter.filterParams.tag" />
      <span class="option">{{ option.label | translate }}</span>
    </label>
  </div>
</ng-template>
